import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { EquityEntity } from '@genial/services';
import { Box, Text } from 'native-base';
import React from 'react';

import { rendaVariavelBuy, rendaVariavelSell } from '../../colors';

import { LoadingBuySellInfo } from './loading';
interface BuySellInfoProps extends EquityEntity {
  isLoading?: boolean;
}

export const BuySellInfo: React.FC<BuySellInfoProps> = ({
  quote: {
    bookInfoBuy: { orderBook: orderBookBuy },
    bookInfoSell: { orderBook: orderBookSell },
  },
  isLoading,
}) => {
  if (isLoading) {
    return <LoadingBuySellInfo />;
  }

  const orderBookBuyLength = orderBookBuy?.length || 0;
  const orderBookSellLength = orderBookSell?.length || 0;
  const orderBookListLength =
    orderBookBuyLength > orderBookSellLength ? orderBookBuyLength : orderBookSellLength;

  const orderBookData = Array.from({ length: orderBookListLength });

  const unifiedOrderBook = orderBookData?.map((_, index) => ({
    orderBookBuy: orderBookBuy ? { ...orderBookBuy[index] } : null,
    orderBookSell: orderBookSell ? { ...orderBookSell[index] } : null,
  }));

  const items = unifiedOrderBook.map((item, index, array) => (
    <VStack
      key={index.toString()}
      mb={index === array.length - 1 ? 0 : Spacing['stack.xxxs']}
      borderRadius={BoxRadius.sm}
      bg={Color.background}
      p={Spacing['inline.xxxs']}
      space={Spacing['inline.quarck']}>
      <HStack alignItems="center">
        <HStack
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          p={Spacing['inline.nano']}>
          <Text variant="regular" color={Color['neutral.black']}>
            {item.orderBookBuy?.numberOfShares}
          </Text>
          <Box
            alignItems="center"
            justifyContent="center"
            py={Spacing['inline.nano']}
            px={Spacing['inline.xxxs']}
            background={rendaVariavelBuy}
            borderRadius="full">
            <Text variant="semibold" color="white">
              {item.orderBookBuy?.price}
            </Text>
          </Box>
        </HStack>
        <HStack
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          p={Spacing['inline.nano']}>
          <Box
            alignItems="center"
            justifyContent="center"
            py={Spacing['inline.nano']}
            px={Spacing['inline.xxxs']}
            background={rendaVariavelSell}
            borderRadius="full">
            <Text variant="semibold" color="white">
              {item.orderBookBuy?.price}
            </Text>
          </Box>
          <Text variant="regular" color={Color['neutral.black']}>
            {item.orderBookBuy?.numberOfShares}
          </Text>
        </HStack>
      </HStack>
    </VStack>
  ));

  return items;
};
